import React, { memo } from 'react';
import { graphql, useFragment } from 'react-relay';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import type { SaveResetViewSettingsButton$key } from '@atlassian/jira-relay/src/__generated__/SaveResetViewSettingsButton.graphql';
import { PACKAGE_NAME, TEAM_NAME } from '../common/constants.tsx';
import { SaveResetViewSettingsButtonCollapsible } from './SaveResetViewSettingsButtonCollapsible.tsx';

type Props = {
	viewFragment: SaveResetViewSettingsButton$key;
};

export const SaveResetViewSettingsButton = memo(({ viewFragment }: Props) => {
	const viewMetadata = useFragment(
		graphql`
			fragment SaveResetViewSettingsButton on JiraIssueSearchViewMetadata {
				...SaveResetViewSettingsButtonCollapsible @arguments(staticViewInput: $staticViewInput)
			}
		`,
		viewFragment,
	);

	return (
		<JSErrorBoundary
			fallback="unmount"
			id="issue-navigator-save-reset-view-settings-button"
			packageName={PACKAGE_NAME}
			teamName={TEAM_NAME}
		>
			<SaveResetViewSettingsButtonCollapsible viewFragment={viewMetadata} />
		</JSErrorBoundary>
	);
});
